/**
 * Checks if the {@link urlParams} and {@link urlParamsToCompare} are equal.
 * */
export function areUrlParamsEqual(
  urlParams: URLSearchParams,
  urlParamsToCompare: URLSearchParams,
): boolean {
  if (urlParams === urlParamsToCompare) {
    return true;
  }

  const urlParamsKeys = [...urlParams.keys()];
  const urlParamsToCompareKeys = [...urlParamsToCompare.keys()];

  if (urlParamsKeys.length !== urlParamsToCompareKeys.length) {
    return false;
  }

  for (const key of urlParamsKeys) {
    if (urlParams.get(key) !== urlParamsToCompare.get(key)) {
      return false;
    }
  }

  return true;
}
